import { PremieVolksverzekeringenRates } from "./model";

export const rates: PremieVolksverzekeringenRates = {
    2020: {
        premieAOW: 17.9,
        premieAnw: 0.1,
        premieWlz: 9.65,
        to: 34_712
    },
    2021: {
        premieAOW: 17.9,
        premieAnw: 0.1,
        premieWlz: 9.65,
        to: 35_129
    },
    2022: {
        premieAOW: 17.9,
        premieAnw: 0.1,
        premieWlz: 9.65,
        to: 35_472
    },
    2023: {
        premieAOW: 17.9,
        premieAnw: 0.1,
        premieWlz: 9.65,
        to: 37_149
    },
    2024: {
        premieAOW: 17.9,
        premieAnw: 0.1,
        premieWlz: 9.65,
        to: 38_098
    }
};
